import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ImagilityBaseResponse } from 'app-models';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FrequencyAlertService {

  constructor(private http: HttpClient) { }

  getDocFrequencyAlertListing(userId) {
    return this.http.get(`/getDocumentFrequencyDetails/user/${userId}`).pipe(
        map((response: ImagilityBaseResponse) => {
          if (response.status) {
            return response.data;
          }
        })
    );
  }

  saveFrequencyListing(payload, userId, isSaveFor) {
    return this.http.post(`/saveDocumentFrequencyDetails/user/${userId}/${isSaveFor}`, payload)
  }

}
